<app-header></app-header>
<div class="container main-page">
  <div class="row margin-top-70">
    <div class="col-md-6 col-sm-12 col-lg-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Product ID
            </td>
            <td colspan="2">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedproductId"
                placeholder=""
              />
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              Published Date
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              Commit Date
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'commitDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="commitDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 col-sm-12 col-lg-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Status
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectStatusTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'status'"
                [selectedOption]="DefaultselectedOptionType"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-drop-down
                type="bookStatus"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookStatus"
                (dropDownChanged)="updateSelectedDropDown($event)"
                [selectedItems]="selectedDefaultItemsStatus"
              ></app-drop-down>
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              Book Type
            </td>
            <td colspan="2">
              <app-drop-down
                type="bookType"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookType"
                (dropDownChanged)="updateSelectedDropDown($event)"
              ></app-drop-down>
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              PPD
            </td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'ppdDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="ppdDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div>
  <div class="container">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        [disabled]="showSearchLoading"
        type="submit"
        class="btn btn-pkt btn-primary me-1"
        (click)="searchProduct()"
      >
        {{searchBtnText}}
        <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
        <span
          *ngIf="showSearchLoading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>

      <button
        type="submit"
        class="btn btn-pkt btn-success"
        (click)="downloadReport()"
      >
        {{downloadBtnText}}
        <i class="bi bi-download ps-1" *ngIf="!showDownloadLoading"></i>
      </button>
      <span
        *ngIf="showDownloadLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  </div>
  <div class="container table-responsive">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="width-10">Date Created</th>
          <th scope="col" class="width-15">ID</th>
          <th scope="col" class="width-15">Title</th>
          <th scope="col" class="width-15">Brand Id</th>
          <th scope="col" class="width-15">book_pipeline_status</th>
          <th scope="col" class="width-15">Format</th>
          <th scope="col" class="width-15">Product type</th>
          <th scope="col" class="width-15">Business Unit</th>
          <th scope="col" class="width-15">Length Range</th>
          <th scope="col" class="width-15">ISBN-13P</th>
          <th scope="col" class="width-15">Cancelled ISBN-13P</th>
          <th scope="col" class="width-15">ISBN-10P</th>
          <th scope="col" class="width-15">Cancelled ISBN-10P</th>
          <th scope="col" class="width-15">ISBN-13E</th>
          <th scope="col" class="width-15">Cancelled ISBN-13E</th>
          <th scope="col" class="width-15">ISBN-10E</th>
          <th scope="col" class="width-15">Cancelled ISBN-10E</th>
          <th scope="col" class="width-15">Product ID</th>
          <!-- <th scope="col">Format</th> -->
          <th scope="col" class="width-10">Commit Date</th>
          <th scope="col" class="width-10">Contracted Date</th>
          <th scope="col" class="width-10">Handover to Development Date</th>
          <th scope="col" class="width-10">Handover to Production Date</th>
          <th scope="col" class="width-10">Clubbing Completed Date</th>
          <th scope="col" class="width-10">Final Check Completed Date</th>
          <th scope="col" class="width-10">QC Checking Completed Date</th>
          <th scope="col" class="width-10">Final Printers Uploaded Date</th>
          <th scope="col" class="width-10">LS Link Approved Date</th>
          <th scope="col" class="width-10">Cancelled Date</th>
          <th scope="col" class="width-10">Published Date</th>
          <th scope="col" class="width-10">Status</th>
          <th scope="col" class="width-10">EPD</th>
          <th scope="col" class="width-10">ppd</th>
          <th scope="col" class="width-10">PD Accepted</th>
          <th scope="col" class="width-10">Length</th>
          <th scope="col" class="width-10">
            Preliminary Draft Accepted Date
          </th>
          <th scope="col" class="width-10">No Of Chapters</th>
          <!-- <th scope="col">Rank</th> -->
          <th scope="col" class="width-10">book_pipeline_status</th>
          <th scope="col" class="width-10">Book Publisher</th>
          <th scope="col" class="width-10">Video Publisher</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products;">
          <td scope="col">{{product.date_entered}}</td>
          <td scope="col">{{product.id}}</td>
          <td scope="col">{{product.name}}</td>
          <td scope="col">{{product.brand_id}}</td>
          <td scope="col">{{ product.book_pipeline_status}}</td>
          <td scope="col">
            {{ (product?.type && product.type.length > 0) ?
            product.type[0].format : ''}}
          </td>
          <td scope="col">{{product.product_type}}</td>
          <td scope="col">{{product.team?.business_unit}}</td>
          <td scope="col">{{product.book_length}}</td>
          <td scope="col">
            {{product.status[0]?.name != cancelledStatus ? product.isbn?.isbn_13
            : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name == cancelledStatus ? product.isbn?.isbn_13
            : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name != cancelledStatus ? product.isbn?.isbn_10
            : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name == cancelledStatus ? product.isbn?.isbn_10
            : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name != cancelledStatus ?
            product.isbn?.isbn_13e : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name == cancelledStatus ?
            product.isbn?.isbn_13e : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name != cancelledStatus ?
            product.isbn?.isbn_10e : ''}}
          </td>
          <td scope="col">
            {{product.status[0]?.name == cancelledStatus ?
            product.isbn?.isbn_10e : ''}}
          </td>
          <td scope="col">{{product.part_number}}</td>
          <!-- <td scope="col">Format</td> -->
          <td scope="col">{{product.date?.commit_date}}</td>
          <td scope="col">{{product.date?.contracted_date}}</td>
          <td scope="col">{{product.date?.development_date}}</td>
          <td scope="col">{{product.date?.production_date}}</td>
          <td scope="col">{{product.date?.clubbing_completed_date}}</td>
          <td scope="col">{{product.date?.final_check_completed_date}}</td>
          <td scope="col">{{product.date?.qc_checking_completed_date}}</td>
          <td scope="col">{{product.date?.printers_file_prepared_date}}</td>
          <td scope="col">{{product.date?.ipad}}</td>
          <td scope="col">{{product.date?.cancelled_date}}</td>
          <td scope="col">{{product.date?.publishing_date}}</td>
          <td scope="col">
            {{(product?.status && product.status.length > 0) ?
            product.status?.[0].format : ''}}
          </td>
          <td scope="col">{{product.date?.epd}}</td>
          <td scope="col">{{product.date?.ppd}}</td>
          <td scope="col">{{product.pd_accepted_percentage}}</td>
          <td scope="col">{{product.book_length}}</td>
          <td scope="col">{{product.pd_accepted_count}}</td>
          <td scope="col">{{product.chapter_count}}</td>
          <!-- <td scope="col">Rank</td> -->
          <td scope="col">{{product.book_pipeline_status}}</td>
          <td scope="col">{{product.publisher[0]?.name}}</td>
          <td scope="col">{{product.video_publisher[0]?.name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container mt-4">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>
